import React from 'react';
import { usePos } from '../context/PosContext';
import { PRODUCT_EXCEL_HEADERS } from '../services/excel';
import ProductImportExport from '../components/ProductImportExport';
import './Sections.css';
import './ExcelData.css';

// Excel Export & Import (data_export_import_to_excel_fragment.xml / excel_sheet.xml).
// The Android screen exports the Product Master to an .xlsx ("Save File") and
// re-imports it ("Import Excel"), then optionally e-mails it ("Upload Now").
// Here export/import run fully in the browser (CSV + Excel 2003 SpreadsheetML);
// e-mail needs a mail server, so it's replaced by a normal file download.
// The actual buttons + preview modal live in components/ProductImportExport,
// shared with the Products page toolbar.

const ExcelData: React.FC = () => {
  const { products } = usePos();

  return (
    <div className="section-page xl-page">
      <div className="page-header">
        <h1>Excel Export &amp; Import</h1>
        <div className="xl-actions">
          <ProductImportExport />
        </div>
      </div>

      <p className="muted xl-note">
        Exports the Product Master as the <strong>Product Details</strong> sheet
        ({PRODUCT_EXCEL_HEADERS.join(' · ')}). Import the same layout to bulk add / update products
        — rows are matched to existing products by name. E-mailing the sheet needs a mail server,
        so it's replaced here by a file download.
      </p>

      <div className="section-card">
        <div className="xl-card-head">
          <h2 style={{ margin: 0 }}>Products ({products.length})</h2>
        </div>
        {products.length === 0 ? (
          <p className="muted">No products yet. Add some on the Product Master screen first.</p>
        ) : (
          <div className="xl-grid">
            {products.map((p, i) => (
              <div className="xl-item" key={p.id}>
                <div className="xl-item-row">
                  <span className="xl-sno">{i + 1})</span>
                  <span className="xl-name">{p.name}</span>
                  <span className="xl-cat">{p.category || '—'}</span>
                </div>
                <div className="xl-item-sub">
                  <span>Regional: {p.regionalName || '—'}</span>
                  <span>Stock: {p.stock ?? 0}</span>
                </div>
                <div className="xl-item-sub">
                  <span>Weighable: {p.weighable ? 'YES' : 'NO'}</span>
                  <span>Stockable: {p.stockable ? 'YES' : 'NO'}</span>
                </div>
                <div className="xl-item-sub">
                  <span>Tax: {p.taxRatePercent != null ? `${p.taxRatePercent}%` : '—'}</span>
                  <span>Price: {p.price ?? 0}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ExcelData;
